import { diaAccessTech, diaAccessTechFullName } from "../types/index.const";

const diaAccessTechOptions = diaAccessTech.map((el, index) => ({
  value: el,
  label: diaAccessTechFullName[index],
}));

export default diaAccessTechOptions;
